<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M8.6875 9.2125L9.475 10L11.3125 8.1625M4.75 4.75V15.5413C4.75 15.8292 5.06105 16.0097 5.31105 15.8669L7.0265 14.8866C7.24422 14.7622 7.50972 14.7548 7.73401 14.867L9.6646 15.8323C9.87573 15.9379 10.1243 15.9379 10.3354 15.8323L12.266 14.867C12.4903 14.7548 12.7558 14.7622 12.9735 14.8866L14.6889 15.8669C14.939 16.0097 15.25 15.8292 15.25 15.5413V4.75C15.25 3.92157 14.5784 3.25 13.75 3.25H6.25C5.42157 3.25 4.75 3.92157 4.75 4.75Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ConfirmPurchaseIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>